import OrderStatusBadge from './OrderStatusBadge';

export default OrderStatusBadge;
